import { FaUser, FaBriefcase, FaLightbulb, FaChalkboardTeacher } from "react-icons/fa";
import "./asesoria.css";
import RegisterTwo from "../../components/registertwo";

const Asesoria = () => {
  return (
    <div>
      <section className="asesoria-section">
        <div className="container">
          {/* Título principal y subtítulo */}
          <div className="text-center asesoria-title-container">
            <h1 className="display-4">ASESORÍA PERSONALIZADA</h1>
            <p className="lead">
              Sesiones diseñadas para potenciar tu carrera, emprendimiento y crecimiento personal.
            </p>
          </div>

          {/* Tarjetas de asesoría */}
          <div className="row g-4 mb-4">
            {/* Asesoría Personal */}
            <div className="col-12 col-md-6 col-lg-3">
              <div className="card asesoria-card">
                <div className="card-body text-center">
                  <div className="icon-circle">
                    <FaUser className="icon" />
                  </div>
                  <h2 className="asesoria-card-title">Asesoría Personal</h2>
                  <p className="text-muted">
                    Mejora tu bienestar personal con estrategias a medida.
                  </p>
                </div>
              </div>
            </div>
            {/* Asesoría de Carrera */}
            <div className="col-12 col-md-6 col-lg-3">
              <div className="card asesoria-card">
                <div className="card-body text-center">
                  <div className="icon-circle">
                    <FaBriefcase className="icon" />
                  </div>
                  <h2 className="asesoria-card-title">Asesoría de Carrera</h2>
                  <p className="text-muted">
                    Impulsa tu desarrollo profesional con orientación personalizada.
                  </p>
                </div>
              </div>
            </div>
            {/* Asesoría de Emprendimiento */}
            <div className="col-12 col-md-6 col-lg-3">
              <div className="card asesoria-card">
                <div className="card-body text-center">
                  <div className="icon-circle">
                    <FaLightbulb className="icon" />
                  </div>
                  <h2 className="asesoria-card-title">Asesoría de Emprendimiento</h2>
                  <p className="text-muted">
                    Lanza y haz crecer tu negocio con estrategias expertas.
                  </p>
                </div>
              </div>
            </div>
            {/* Mentoría y Liderazgo */}
            <div className="col-12 col-md-6 col-lg-3">
              <div className="card asesoria-card">
                <div className="card-body text-center">
                  <div className="icon-circle">
                    <FaChalkboardTeacher className="icon" />
                  </div>
                  <h2 className="asesoria-card-title">Mentoría y Liderazgo</h2>
                  <p className="text-muted">
                    Desarrolla tus habilidades directivas con mentoría especializada.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Botón de llamada a la acción */}
          <div className="text-center mt-4">
            <button className="btn btn-warning">RESERVA TU SESIÓN</button>
          </div>
        </div>
      </section>
      <section>
        {/* Componente de Registro (full width) */}
        <RegisterTwo />
      </section>
    </div>
  );
};

export default Asesoria;